import * as Sentry from '@sentry/react'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
  showErrorNotification,
  showSuccessNotification,
} from '../actions/notificationActions'
import * as actionType from '../actionTypes/gameActionTypes'
import * as actions from '../actions/gameActions'
import { api } from '../../api/rootApi'
import socket from '../../utils/socketIO'
import jwt_decode from 'jwt-decode'
import i18next from '../../i18n'
// import { IPuzzle } from './../types/gameBuilder'

/*
  Worker Saga: Fired on FETCH_PARTNERS_REQUEST action
*/
function* fetchPartnersSaga() {
  try {
    const response: { data: any } = yield call(api.game.partnerList)

    yield put(
      actions.fetchPartnersSuccess({
        partners: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchPartnersFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on POST_GAME_CODE_REQUEST action
*/
function* postGameCodeSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.gameCode,
      action.payload.gameCode,
    )

    yield put(
      actions.postGameCodeSuccess({
        data: response.data.data,
      }),
    )
    localStorage.setItem('tokenCityHunt', JSON.stringify(response.data.data))
    if (action.payload.redirect === 'instructions') {
      action.payload.navigate('/instructions')
    } else {
      action.payload.navigate('/choose-language')
    }
  } catch (e: any) {
    Sentry.captureException(e)
    if (e.response.status === 409 || e.response.status === 404) {
      yield put(showErrorNotification(e.response.data.message))
      yield put(
        actions.postGameCodeFailure({
          error: e.toString(),
        }),
      )
      return
    }
    // yield put(
    //   actions.postGameCodeFailure({
    //     error: e.toString(),
    //     // error: e.errorInfo.message,
    //   }),
    // )
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on POST_FREE_GAME_LOGIN_REQUEST action
*/
function* postFreeGameLoginSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.freeGameLogin,
      action.payload.gameId,
    )

    yield put(
      actions.postFreeGameLoginSuccess({
        data: response.data.data,
      }),
    )
    localStorage.setItem('tokenCityHunt', JSON.stringify(response.data.data))

    action.payload.navigate('/choose-language')
  } catch (e: any) {
    Sentry.captureException(e)
    if (e.response.status === 409 || e.response.status === 404) {
      yield put(showErrorNotification(e.response.data.message))
      return
    }
    // yield put(
    //   actions.postGameCodeFailure({
    //     error: e.toString(),
    //     // error: e.errorInfo.message,
    //   }),
    // )
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on POST_TEAM_NAME_REQUEST action
*/
function* postTeamNameSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.addTeamName,
      action.payload.teamName,
    )

    // console.log('postGameInfoSaga', response)

    yield put(
      actions.addTeamNameSuccess({
        data: response.data.data,
      }),
    )
    action.payload.navigate('/qr-code-login')
  } catch (e: any) {
    Sentry.captureException(e)
    if (e.response.status === 409) {
      yield put(showErrorNotification(e.response.data.message))
    }
    yield put(
      actions.addTeamNameFailure({
        error: e.toString(),
      }),
    )
  }
}

/*
  Worker Saga: Fired on PUT_TEAM_NAME_REQUEST action
*/
function* putTeamNameSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.updateTeamName,
      action.payload.teamName,
    )

    yield put(
      actions.putTeamNameSuccess({
        data: response.data.data,
      }),
    )
    yield put(showSuccessNotification('Successfully updated team name!'))
  } catch (e: any) {
    yield put(
      actions.putTeamNameFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on POST_BOOK_GAME_REQUEST action
*/
function* postBookGameSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.bookGame,
      action.payload,
    )

    yield put(
      actions.bookGameSuccess({
        data: response.data.data,
      }),
    )
    yield put(showSuccessNotification('Successfully booked game!'))
  } catch (e: any) {
    yield put(
      actions.bookGameFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_BOOKED_GAMES_BY_USER_REQUEST action
*/
function* fetchBookedGamesByUserSaga() {
  try {
    const response: { data: any } = yield call(api.game.bookedGamesByUsers)

    yield put(
      actions.fetchBookedGamesByUserSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchBookedGamesByUserFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_BOOKED_GAMES_BY_CITIES_REQUEST action
*/
function* fetchGamesByCitiesSaga() {
  try {
    const response: { data: any } = yield call(api.game.bookedGamesByCities)

    yield put(
      actions.fetchBookedGamesByCitiesSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchBookedGamesByCitiesFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_REQUEST action
*/
function* fetchGamesTotalsInRangeSaga() {
  try {
    const response: { data: any } = yield call(
      api.game.bookedGamesTotalsInRange,
    )

    yield put(
      actions.fetchBookedGamesTotalsInRangeSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchBookedGamesTotalsInRangeFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_BOOKED_GAMES_TOTALS_REQUEST action
*/
function* fetchGamesTotalsSaga() {
  try {
    const response: { data: any } = yield call(api.game.bookedGamesTotals)

    yield put(
      actions.fetchBookedGamesTotalsSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchBookedGamesTotalsFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_LEADERBOARD_REQUEST action
*/
function* fetchLeaderboardSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getLeaderboard,
      action.payload,
    )

    yield put(
      actions.fetchLeaderboardSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchLeaderboardFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_TEAM_ON_LEADERBOARD_REQUEST action
*/
function* fetchTeamOnLeaderboardSaga() {
  try {
    const response: { data: any } = yield call(api.game.getTeamOnLeaderboard)

    yield put(
      actions.fetchTeamOnLeaderboardSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchTeamOnLeaderboardFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_GAMES_BY_USER_REQUEST action
*/
function* fetchGamesByUserSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getGamesByUser,
      action.payload,
    )

    yield put(
      actions.fetchGamesByUserSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchGamesByUserFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_GAME_CODE_REQUEST action
*/
function* fetchGameCodeSaga() {
  try {
    const response: { data: any } = yield call(api.game.getGameCode)

    yield put(
      actions.fetchGameCodeSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchGameCodeFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_WELCOME_SCREEN_REQUEST action
*/
function* fetchWelcomeScreenSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getWelcomeScreen,
      action.payload,
    )

    let html = response.data.data.html

    if (html.includes('[teamName]')) {
      const responseTeamName: { data: any } = yield call(api.game.getTeamName)

      let teamName = responseTeamName.data.data

      html = html.replace('[teamName]', teamName)

      yield put(actions.fetchTeamNameSuccess(responseTeamName.data.data))
    }

    response.data.data.html = html

    yield put(
      actions.fetchWelcomeScreenSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchWelcomeScreenFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}
/*
  Worker Saga: Fired on FETCH_END_SCREEN_REQUEST action
*/
function* fetchEndScreenSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getEndScreen,
      action.payload,
    )

    let html = response.data.data.html

    if (html.includes('[teamName]')) {
      const responseTeamName: { data: any } = yield call(api.game.getTeamName)

      let teamName = responseTeamName.data.data

      html = html.replace('[teamName]', teamName)

      yield put(actions.fetchTeamNameSuccess(responseTeamName.data.data))
    }

    response.data.data.html = html

    yield put(
      actions.fetchEndScreenSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchEndScreenFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_GAME_LOCALES_REQUEST action
*/
function* fetchGameLocalesSaga(action: any) {
  try {
    const response: { data: any } = yield call(api.game.getGameLocales)

    if (response.data.data.length) {
      yield put(
        actions.fetchGameLocalesSuccess({
          data: response.data.data,
        }),
      )
    }
  } catch (e: any) {
    yield put(
      actions.fetchGameLocalesFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_MAP_STYLE_REQUEST action
*/
function* fetchMapStyleSaga() {
  try {
    const response: { data: any } = yield call(api.game.getMapStyle)

    yield put(
      actions.fetchMapStyleSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchMapStyleFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_LOCATIONS_ON_MAP_REQUEST action
*/
function* fetchLocationsOnMapSaga() {
  try {
    const response: { data: any } = yield call(api.game.getLocationsOnMap)

    yield put(
      actions.fetchLocationsOnMapSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchLocationsOnMapFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on POST_PUZZLE_ANSWER_REQUEST action
*/
function* postPuzzleAnswerSaga(action: any) {
  try {
    let response: { data: any } = yield call(
      api.game.postPuzzleAnswer,
      action.payload.body,
    )
    response.data.data.questionId = action.payload.body.questionIdGuid
    // yield put(showSuccessNotification('Successfully entered answer!'))
    // if (response.data.data.isCorrect) {
    //   action.payload.navigate('/game/puzzle/well-done')
    // }
    if (!response.data.data.isCorrect) {
      yield put(showErrorNotification(i18next.t('WrongAnswer')))
      yield put(
        actions.postPuzzleAnswerSuccess({
          data: response.data.data,
        }),
      )
    } else {
      const { pointsEarned, solvedPuzzles } = response.data.data

      let wellDoneHtml = response.data.data.wellDoneHtml

      if (wellDoneHtml.includes('[teamName]')) {
        const responseTeamName: { data: any } = yield call(api.game.getTeamName)

        let teamName = responseTeamName.data.data

        wellDoneHtml = wellDoneHtml.replace('[teamName]', teamName)

        yield put(actions.fetchTeamNameSuccess(responseTeamName.data.data))
      }

      if (wellDoneHtml.includes('[points]')) {
        wellDoneHtml = wellDoneHtml.replace('[points]', pointsEarned)
      }

      if (wellDoneHtml.includes('[solvedPuzzlesCount]')) {
        wellDoneHtml = wellDoneHtml.replace(
          '[solvedPuzzlesCount]',
          solvedPuzzles.split('/')[0],
        )
      }

      if (wellDoneHtml.includes('[gamePuzzlesCount]')) {
        wellDoneHtml = wellDoneHtml.replace(
          '[gamePuzzlesCount]',
          solvedPuzzles.split('/')[1],
        )
      }

      response.data.data.wellDoneHtml = wellDoneHtml

      const correctData = response.data.data

      yield put(
        actions.postPuzzleAnswerSuccess({
          data: correctData,
        }),
      )
      const token = localStorage.getItem('tokenCityHunt') ?? ''
      const { TeamId }: any = jwt_decode(token)
      correctData.typeOfAction = 'correctAnswer'
      correctData.localeId = action.payload.body.supportedLocaleId
      socket.emit('remove-room', TeamId, correctData)
    }
  } catch (e: any) {
    yield put(
      actions.postPuzzleAnswerFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    if (e.response.status === 409) {
      action.payload.navigate('/game')
    } else {
      yield put(showErrorNotification(e.toString()))
    }
  }
}

function* fetchQuestionSolvedPuzzleByLocale(action: any) {
  try {
    const { questionId, localeId } = action.payload

    if (action.payload.typeOfAction === 'correctAnswer') {
      const response: { data: any } = yield call(
        api.game.getQuestionWellDoneByLocale,
        { questionId, localeId },
      )
      const { pointsEarned, solvedPuzzles } = action.payload
      let wellDoneHtml = response.data.data.wellDoneHtml

      if (wellDoneHtml.includes('[teamName]')) {
        const responseTeamName: { data: any } = yield call(api.game.getTeamName)

        let teamName = responseTeamName.data.data

        wellDoneHtml = wellDoneHtml.replace('[teamName]', teamName)

        yield put(actions.fetchTeamNameSuccess(responseTeamName.data.data))
      }

      if (wellDoneHtml.includes('[points]')) {
        wellDoneHtml = wellDoneHtml.replace('[points]', pointsEarned)
      }

      if (wellDoneHtml.includes('[solvedPuzzlesCount]')) {
        wellDoneHtml = wellDoneHtml.replace(
          '[solvedPuzzlesCount]',
          solvedPuzzles.split('/')[0],
        )
      }

      if (wellDoneHtml.includes('[gamePuzzlesCount]')) {
        wellDoneHtml = wellDoneHtml.replace(
          '[gamePuzzlesCount]',
          solvedPuzzles.split('/')[1],
        )
      }

      action.payload.wellDoneHtml = wellDoneHtml
      action.payload.collectedItemImageUrl =
        response.data.data.collectedItemImageUrl
    } else {
      const response: { data: any } = yield call(
        api.game.getQuestionSkipByLocale,
        { questionId, localeId },
      )
      const { solvedPuzzles } = action.payload
      let skipHtml = response.data.data.skipHtml

      if (skipHtml.includes('[teamName]')) {
        const responseTeamName: { data: any } = yield call(api.game.getTeamName)

        let teamName = responseTeamName.data.data

        skipHtml = skipHtml.replace('[teamName]', teamName)

        yield put(actions.fetchTeamNameSuccess(responseTeamName.data.data))
      }

      if (skipHtml.includes('[solvedPuzzlesCount]')) {
        skipHtml = skipHtml.replace(
          '[solvedPuzzlesCount]',
          solvedPuzzles.split('/')[0],
        )
      }

      if (skipHtml.includes('[gamePuzzlesCount]')) {
        skipHtml = skipHtml.replace(
          '[gamePuzzlesCount]',
          solvedPuzzles.split('/')[1],
        )
      }
      action.payload.skipHtml = skipHtml
      action.payload.collectedItemImageUrl =
        response.data.data.collectedItemImageUrl
    }

    yield put(
      actions.fetchQuestionSolvedPuzzleByLocaleSuccess({
        data: action.payload,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchQuestionSolvedPuzzleByLocaleFailure({
        data: action.payload,
      }),
    )
    Sentry.captureException(e)
  }
}

/*
  Worker Saga: Fired on FETCH_QUESTION_BY_LOCALE_REQUEST action
*/
function* fetchQuestionByLocaleSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getQuestionByLocale,
      action.payload,
    )

    yield put(
      actions.fetchQuestionByLocaleSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchQuestionByLocaleFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}
/*
  Worker Saga: Fired on FETCH_QUESTION_BY_LOCALE_REQUEST action
*/
function* fetchIsQuestionSolvedSaga(action: any) {
  try {
    let response: { data: any } = yield call(
      api.game.getIsQuestionSolved,
      action.payload,
    )
    response.data.data.wellDoneResponse.questionId = action.payload.questionId
    yield put(
      actions.fetchIsQuestionSolvedSuccess({
        data: response.data.data,
        questionId: action.payload.questionId,
        reason: action.payload.reason,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchIsQuestionSolvedFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
  }
}

/*
  Worker Saga: Fired on POST_PUZZLE_HINT_REQUEST action
*/
function* postPuzzleHintSaga(action: any) {
  try {
    let body = { ...action.payload }
    delete body.navigate
    const response: { data: any } = yield call(api.game.postPuzzleHint, body)

    // console.log('postGameInfoSaga', response)

    yield put(
      actions.postPuzzleHintSuccess({
        data: response.data.data,
      }),
    )
    // yield put(showSuccessNotification('Successfully used hint!'))
    if (response.data.data) {
      // yield put(actions.fetchUsedHintsRequest(action))
      const responseUsedHint: { data: any } = yield call(
        api.game.getUsedHints,
        {
          questionId: action.payload.questionId,
          localeId: action.payload.supportedLocaleId,
        },
      )

      yield put(
        actions.fetchUsedHintsSuccess({
          data: responseUsedHint.data.data,
        }),
      )
    }
  } catch (e: any) {
    yield put(
      actions.postPuzzleHintFailure({
        error: e.toString(),
      }),
    )

    Sentry.captureException(e)

    if (e.response.status === 409) {
      action.payload.navigate('/game')
    } else {
      yield put(showErrorNotification(e.toString()))
    }
  }
}

/*
  Worker Saga: Fired on FETCH_USED_HINTS_REQUEST action
*/
function* fetchUsedHintsSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getUsedHints,
      action.payload,
    )

    yield put(
      actions.fetchUsedHintsSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchUsedHintsFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on POST_SKIP_PUZZLE_REQUEST action
*/
function* postSkipPuzzleSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.postSkipPuzzle,
      action.payload,
    )

    // console.log('postGameInfoSaga', response)

    const { solvedPuzzles } = response.data.data

    let skipHtml = response.data.data.skipHtml

    if (skipHtml.includes('[teamName]')) {
      const responseTeamName: { data: any } = yield call(api.game.getTeamName)

      let teamName = responseTeamName.data.data

      skipHtml = skipHtml.replace('[teamName]', teamName)

      yield put(actions.fetchTeamNameSuccess(responseTeamName.data.data))
    }

    if (skipHtml.includes('[solvedPuzzlesCount]')) {
      skipHtml = skipHtml.replace(
        '[solvedPuzzlesCount]',
        solvedPuzzles.split('/')[0],
      )
    }

    if (skipHtml.includes('[gamePuzzlesCount]')) {
      skipHtml = skipHtml.replace(
        '[gamePuzzlesCount]',
        solvedPuzzles.split('/')[1],
      )
    }

    response.data.data.skipHtml = skipHtml

    const skipData = response.data.data

    yield put(
      actions.postSkipPuzzleSuccess({
        data: skipData,
      }),
    )

    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const { TeamId }: any = jwt_decode(token)

    skipData.typeOfAction = 'puzzleSkipped'
    if (!action.payload.skipFrom) {
      socket.emit('remove-room', TeamId, skipData)
    } else {
      socket.emit('skip-puzzle', TeamId, skipData)
    }
  } catch (e: any) {
    yield put(
      actions.postSkipPuzzleFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    if (e.response.status === 409) {
      action.payload.navigate('/game')
    } else {
      yield put(showErrorNotification(e.toString()))
    }
  }
}

/*
  Worker Saga: Fired on FETCH_COLLECTED_ITEMS_REQUEST action
*/
function* fetchCollectedItemsSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getCollectedItems,
      action.payload,
    )

    yield put(
      actions.fetchCollectedItemsSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchCollectedItemsFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_FINAL_PUZZLE_REQUEST action
*/
function* fetchFinalPuzzleSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getFinalPuzzle,
      action.payload,
    )

    yield put(
      actions.fetchFinalPuzzleSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchFinalPuzzleFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

function* checkIfTeamNameIsAddedSaga() {
  try {
    const response: { data: any } = yield call(api.game.checkIfTeamNameIsAdded)

    yield put(actions.checkIfTeamNameIsAddedSuccess(response.data.data))
  } catch (e: any) {
    yield put(actions.checkIfTeamNameIsAddedFailure(e.toString()))
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

function* fetchTeamNameSaga() {
  try {
    const response: { data: any } = yield call(api.game.getTeamName)

    yield put(actions.fetchTeamNameSuccess(response.data.data))
  } catch (e: any) {
    yield put(actions.fetchTeamNameFailure(e.toString()))
    Sentry.captureException(e)
  }
}

function* checkEndTimerSaga() {
  try {
    const response: { data: any } = yield call(api.game.checkIfTimerIsSet)
    const { teamId, timerTime, timerEndReminderTime, timerDescription } =
      response.data.data
    if (timerTime) {
      socket.emit('start-game-timer', {
        teamId,
        timerTime: timerTime * 60,
        timerEndReminderTime: timerEndReminderTime * 60,
        timerDescription,
      })
    }

    yield put(actions.checkIfTimerIsSetSuccess(response.data.data))
  } catch (e: any) {
    yield put(actions.checkIfTimerIsSetFailure(e.toString()))
    Sentry.captureException(e)
  }
}

function* fetchProgressSaga() {
  try {
    const response: { data: any } = yield call(api.game.getProgress)

    yield put(actions.fetchProgressSuccess(response.data.data))
  } catch (e: any) {
    yield put(actions.fetchProgressFailure(e.toString()))
    Sentry.captureException(e)
  }
}

function* fetchLegalUrlsSaga() {
  try {
    const response: { data: any } = yield call(api.game.legalUrls)

    yield put(actions.fetchLegalUrlsSuccess(response.data.data))
  } catch (e: any) {
    yield put(actions.fetchLegalUrlsFailure(e.toString()))
    Sentry.captureException(e)
  }
}

/*
  Worker Saga: Fired on POST_LOGOUT_REQUEST action
*/
function* postLogoutSaga(action: any) {
  try {
    const response: { data: any } = yield call(api.game.postLogout)

    yield put(
      actions.postLogoutSuccess({
        data: response.data.data,
      }),
    )

    localStorage.removeItem('tokenCityHunt')
    window.location.reload()
  } catch (e: any) {
    Sentry.captureException(e)
    localStorage.removeItem('tokenCityHunt')
    window.location.reload()
  }
}

/*
  Worker Saga: Fired on FETCH_WELL_DONE_BACKGROUND_REQUEST action
*/
function* fetchWellDoneBackgroundSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getPuzzleWellDoneBackground,
      {
        questionId: action.payload.questionId,
      },
    )

    // console.log('Partners response', response)

    yield put(
      actions.fetchWellDoneBackgroundSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchWellDoneBackgroundFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

/*
  Worker Saga: Fired on FETCH_WELL_DONE_BACKGROUND_REQUEST action
*/
function* fetchInitialDataSaga(action: any) {
  try {
    const response: { data: any } = yield call(
      api.game.getInitialData,
      action.payload,
    )

    // console.log('Partners response', response)

    yield put(
      actions.fetchInitialDataSuccess({
        data: response.data.data,
      }),
    )
    localStorage.setItem('hunt-branding', JSON.stringify(response.data.data))
  } catch (e: any) {
    yield put(
      actions.fetchInitialDataFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

function* fetchConsentSaga(action: any) {
  try {
    const response: { data: any } = yield call(api.game.getConsent, {
      gameId: action.payload.gameId,
      localeId: action.payload.localeId,
    })

    yield put(
      actions.fetchGameConsentSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchGameConsentFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}
function* fetchInstructionsSaga(action: any) {
  try {
    const response: { data: any } = yield call(api.game.getInstructions, {
      gameId: action.payload.gameId,
      localeId: action.payload.localeId,
    })

    yield put(
      actions.fetchGameInstructionsSuccess({
        data: response.data.data,
      }),
    )
  } catch (e: any) {
    yield put(
      actions.fetchGameInstructionsFailure({
        error: e.toString(),
      }),
    )
    Sentry.captureException(e)
    yield put(showErrorNotification(e.toString()))
  }
}

function* gameSaga() {
  yield all([
    takeLatest(actionType.FETCH_PARTNERS_REQUEST, fetchPartnersSaga),
    takeLatest(actionType.POST_GAME_CODE_REQUEST, postGameCodeSaga),
    takeLatest(actionType.POST_FREE_GAME_LOGIN_REQUEST, postFreeGameLoginSaga),
    takeLatest(actionType.POST_TEAM_NAME_REQUEST, postTeamNameSaga),
    takeLatest(
      actionType.CHECK_IF_TEAM_NAME_IS_ADDED_REQUEST,
      checkIfTeamNameIsAddedSaga,
    ),
    takeLatest(actionType.PUT_TEAM_NAME_REQUEST, putTeamNameSaga),
    takeLatest(actionType.POST_BOOK_GAME_REQUEST, postBookGameSaga),
    takeLatest(
      actionType.FETCH_BOOKED_GAMES_BY_USER_REQUEST,
      fetchBookedGamesByUserSaga,
    ),
    takeLatest(
      actionType.FETCH_BOOKED_GAMES_BY_CITIES_REQUEST,
      fetchGamesByCitiesSaga,
    ),
    takeLatest(
      actionType.FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_REQUEST,
      fetchGamesTotalsInRangeSaga,
    ),
    takeLatest(
      actionType.FETCH_BOOKED_GAMES_TOTALS_REQUEST,
      fetchGamesTotalsSaga,
    ),
    takeLatest(actionType.FETCH_LEADERBOARD_REQUEST, fetchLeaderboardSaga),
    takeLatest(
      actionType.FETCH_TEAM_ON_LEADERBOARD_REQUEST,
      fetchTeamOnLeaderboardSaga,
    ),
    takeLatest(actionType.FETCH_GAMES_BY_USER_REQUEST, fetchGamesByUserSaga),
    takeLatest(actionType.FETCH_GAME_CODE_REQUEST, fetchGameCodeSaga),
    takeLatest(actionType.FETCH_WELCOME_SCREEN_REQUEST, fetchWelcomeScreenSaga),
    takeLatest(actionType.FETCH_END_SCREEN_REQUEST, fetchEndScreenSaga),
    takeLatest(actionType.FETCH_GAME_LOCALES_REQUEST, fetchGameLocalesSaga),
    takeLatest(actionType.FETCH_MAP_STYLE_REQUEST, fetchMapStyleSaga),
    takeLatest(
      actionType.FETCH_LOCATIONS_ON_MAP_REQUEST,
      fetchLocationsOnMapSaga,
    ),
    takeLatest(actionType.POST_PUZZLE_ANSWER_REQUEST, postPuzzleAnswerSaga),
    takeLatest(
      actionType.FETCH_QUESTION_BY_LOCALE_REQUEST,
      fetchQuestionByLocaleSaga,
    ),
    takeLatest(
      actionType.FETCH_IS_QUESTION_SOLVED_REQUEST,
      fetchIsQuestionSolvedSaga,
    ),
    takeLatest(actionType.POST_PUZZLE_HINT_REQUEST, postPuzzleHintSaga),
    takeLatest(actionType.FETCH_LEGAL_URLS_REQUEST, fetchLegalUrlsSaga),
    takeLatest(actionType.FETCH_USED_HINTS_REQUEST, fetchUsedHintsSaga),
    takeLatest(actionType.POST_SKIP_PUZZLE_REQUEST, postSkipPuzzleSaga),
    takeLatest(
      actionType.FETCH_COLLECTED_ITEMS_REQUEST,
      fetchCollectedItemsSaga,
    ),
    takeLatest(actionType.FETCH_FINAL_PUZZLE_REQUEST, fetchFinalPuzzleSaga),
    takeLatest(actionType.FETCH_TEAM_NAME_REQUEST, fetchTeamNameSaga),
    takeLatest(actionType.FETCH_PROGRESS_REQUEST, fetchProgressSaga),
    takeLatest(actionType.CHECK_TIMER_SET_REQUEST, checkEndTimerSaga),
    takeLatest(actionType.POST_LOGOUT_REQUEST, postLogoutSaga),
    takeLatest(
      actionType.FETCH_WELL_DONE_BACKGROUND_REQUEST,
      fetchWellDoneBackgroundSaga,
    ),
    takeLatest(actionType.FETCH_INITIAL_DATA_REQUEST, fetchInitialDataSaga),
    takeLatest(actionType.FETCH_GAME_CONSENT_REQUEST, fetchConsentSaga),
    takeLatest(
      actionType.FETCH_GAME_INSTRUCTIONS_REQUEST,
      fetchInstructionsSaga,
    ),
    takeLatest(
      actionType.FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_REQUEST,
      fetchQuestionSolvedPuzzleByLocale,
    ),
  ])
}

export default gameSaga
